import { Link } from "react-router-dom";

export default function Legal() {
  return (
    <div className="mx-auto max-w-3xl p-4 sm:p-6">
      <div className="mb-4">
        <Link to="/" className="text-xs text-slate-400 hover:text-slate-200">
          ← Back
        </Link>
      </div>
      <article className="prose prose-invert prose-sm max-w-none rounded-2xl border border-slate-800 bg-slate-900/40 p-5 sm:p-7">
        <h1 className="mb-2 text-xl font-semibold tracking-tight text-slate-100 sm:text-2xl">
          Disclaimer
        </h1>
        <p className="text-xs text-slate-500">Last updated: 2026-05-03</p>

        <p className="mt-4 text-sm leading-relaxed text-slate-300">
          stux is a personal tool. Output is{" "}
          <span className="text-amber-300">AI-generated and not financial advice</span>.
          Nothing you see here constitutes a recommendation to buy, sell, or hold any
          security. Consult a qualified, licensed advisor before making investment
          decisions.
        </p>

        <h2 className="mt-6 text-sm font-semibold text-slate-100">Data sources</h2>
        <p className="mt-2 text-sm leading-relaxed text-slate-300">
          stux pulls market and news data from third-party providers including
          yfinance, Marketaux, apewisdom, stocktwits, and SEC EDGAR. This data may be
          delayed, incomplete, or wrong. AI analysis is generated by large language
          models and can hallucinate, miss context, or contradict itself across
          re-runs.
        </p>

        <h2 className="mt-6 text-sm font-semibold text-slate-100">No warranty</h2>
        <p className="mt-2 text-sm leading-relaxed text-slate-300">
          The service is provided as-is, with no warranties of any kind. Use at your
          own risk. The author is not liable for any losses arising from your use of
          stux.
        </p>

        <h2 className="mt-6 text-sm font-semibold text-slate-100">Privacy</h2>
        <p className="mt-2 text-sm leading-relaxed text-slate-300">
          stux is invite-only and stores: your Google account email and id (for
          sign-in), your watchlist, in-app preferences, and usage telemetry. Account
          deletion is available from{" "}
          <Link to="/settings" className="underline hover:text-slate-100">
            Settings
          </Link>{" "}
          and removes your data from the application database. Backups are retained
          for up to 30 days.
        </p>

        <h2 className="mt-6 text-sm font-semibold text-slate-100">Contact</h2>
        <p className="mt-2 text-sm leading-relaxed text-slate-300">
          Questions or concerns:{" "}
          <a
            href="mailto:mehdi.towhidi@gmail.com?subject=stux"
            className="underline hover:text-slate-100"
          >
            mehdi.towhidi@gmail.com
          </a>
          .
        </p>
      </article>
    </div>
  );
}
